import SyntaxHighlight from "react-syntax-highlighter";
import { useContext } from "react";
import { AppContext } from "../../AppContext";
import { defaultStyle } from "react-syntax-highlighter/dist/esm/styles/hljs";
import github from "react-syntax-highlighter/dist/esm/styles/hljs/stackoverflow-dark";

const SyntaxHighlighter = (props) => {
    const appContext = useContext(AppContext);
    const { theme } = appContext;
    return (
        <SyntaxHighlight
            {...props}
            style={theme === "dark" ? github : defaultStyle}
            customStyle={{ fontSize: 14 }}
            lineNumberStyle={{ marginLeft: -10, marginRight: 10, color: 'gray' }}
        />
    );
};
export default SyntaxHighlighter;
